import Request from "./Request";
import Rules from "./Rules";
import IframeRequest from "./IframeRequest";
import Plugin from "./Plugin";
import * as funcs from "./funcs";

export default class ResolverManager {
  constructor(options = {}) {
    this.resolvers = {};
    this.parsedResolvers = [];
    this.registeredResolvers = {
      rules: Rules, // 根据schema中rule规则校验配置，处理表单field校验
      request: Request, // 根据schema中异步request配置，处理异步请求
      iframeRequest: IframeRequest, // 根据schema中iframeRequest配置，实现iframe弹窗场景
      plugin: Plugin,
    };
    this.registeredFunctions = {
      ...funcs,
    };
    this.listenersMap = {};
    this.fieldApi = options.fieldApi;
    this.schema = options.schema;
    this.context = options.context;
    this.isDetail = options.isDetail;
    this.params = options.params;
    this.isEdit = options.isEdit;
    this.disableDevicePlugin = options.disableDevicePlugin;
    this.updateRequestCounter = options.updateRequestCounter;
    this.initResolvers();
  }

  registerResolver = (name, resolver) => {
    this.registeredResolvers[name] = resolver;
    return this;
  };

  registerFunc = (name, func) => {
    this.registeredFunctions[name] = func;
    return this;
  };

  initResolvers = () => {
    Object.keys(this.registeredResolvers).map((name) => {
      const Resolver = this.registeredResolvers[name];
      const resolver = new Resolver({
        owner: this,
        schema: this.schema,
        context: this.context,
        fieldApi: this.fieldApi,
        funcs: this.registeredFunctions,
        isDetail: this.isDetail,
        isEdit: this.isEdit,
        disableDevicePlugin: this.disableDevicePlugin,
        params: this.params,
        updateRequestCounter: this.updateRequestCounter,
      });
      this.resolvers[name] = resolver;

      return resolver;
    });
    return this;
  };

  parse = (names) => {
    Object.keys(this.resolvers).forEach((name) => {
      if (!names || names.includes(name)) {
        const resolver = this.resolvers[name];
        resolver.parse && resolver.parse();
        this.parsedResolvers.push(resolver);
      }
    });
    return this;
  };

  apply = () => {
    this.parsedResolvers.forEach((resolver) => {
      resolver.apply && resolver.apply();
    });
    return this;
  };

  rebind = () => {
    this.parsedResolvers.forEach((resolver) => {
      resolver.rebind && resolver.rebind();
    });
    return this;
  };

  /**
   * 执行回调
   */
  execListener = (id) => {
    const listener = this.listenersMap[id];
    return listener.run();
  };

  /**
   * 解析出绑定在组件上的方法
   */
  toProps = (names) => {
    const event = {};
    Object.keys(this.listenersMap).forEach((uuid) => {
      const listener = this.listenersMap[uuid];
      if (names && !names.includes(listener.type)) return;

      const eventProps = listener.toProps();
      Object.keys(eventProps).forEach((fieldId) => {
        Object.keys(eventProps[fieldId]).forEach((eventName) => {
          if (!event[fieldId]) event[fieldId] = {};
          if (!event[fieldId][eventName]) event[fieldId][eventName] = [];
          event[fieldId][eventName].push(eventProps[fieldId][eventName]);
        });
      });
    });

    return event;
  };
}
